import {lazy} from 'react';

import {suspendWithForwardRef} from 'util/suspend';

import type {ImageEditorProps} from './ImageEditor';

const ImageEditor = lazy(() => import(/* webpackChunkName: "image-editor" */ './ImageEditor'));

export default suspendWithForwardRef<ImageEditorProps>(ImageEditor);
